import { IIntegrationProps } from './types';
import { api } from '../DefaultService';

const ENDPOINT = 'v1/integrations';

export const getAllIntegrationsByLicenseAsync = async (): Promise<
  IIntegrationProps[]
> => {
  return await api
    .get<IIntegrationProps[]>(ENDPOINT + '/getAllByLicense')
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteIntegrationsAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
